import { render, staticRenderFns } from "./pendingLrs.vue?vue&type=template&id=5ab11535&"
import script from "./pendingLrs.vue?vue&type=script&lang=js&"
export * from "./pendingLrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports